import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import residentEmailPageData from '../data/servicePages/residentEmail';

const ResidentEmailPage = () => <ServicePageLayout data={residentEmailPageData} />;

export default ResidentEmailPage;
